import React from 'react';
import { Search, MapPin, Phone, Globe, Star, CheckCircle, Edit, Megaphone, Users, ChevronRight, Bookmark, ArrowRight } from 'lucide-react';

export const GoogleOfficialProfileMockup: React.FC = () => {
  return (
    <div className="w-full bg-[#FFFFFF] text-slate-900 font-sans border border-slate-200/90 rounded-3xl overflow-hidden shadow-2xl p-6 md:p-8 text-left space-y-8">
      
      {/* HEADER TITLE */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-slate-100 pb-4">
         <div>
            <div className="flex items-center gap-2">
               <span className="font-black text-xl tracking-tighter">
                  <span className="text-[#4285F4]">G</span>
                  <span className="text-[#EA4335]">o</span>
                  <span className="text-[#FBBC05]">o</span>
                  <span className="text-[#4285F4]">g</span>
                  <span className="text-[#34A853]">l</span>
                  <span className="text-[#EA4335]">e</span>
               </span>
               <span className="text-xs font-bold text-slate-500">• Business Profile Manager</span>
            </div>
            <p className="text-xs text-slate-500 font-medium">Gestão oficial de ficha de empresa e visibilidade no Google Maps.</p>
         </div>

         <span className="bg-blue-50 text-[#4285F4] border border-blue-200 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1.5">
            <CheckCircle className="w-3.5 h-3.5" /> Ficha Verificada Oficial
         </span>
      </div>

      {/* DUAL DISPLAY: DESKTOP ADMIN PANEL (LEFT) + MOBILE GMB CARD (RIGHT) */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
         
         {/* LEFT: GOOGLE DESKTOP ADMIN MANAGER PANEL (RECRIAÇÃO DA IMAGEM 2) */}
         <div className="lg:col-span-8 bg-white border border-slate-200 rounded-2xl p-5 space-y-5 shadow-xs">
            
            {/* Google Search Bar Mockup */}
            <div className="flex items-center gap-3 border-b border-slate-100 pb-3">
               <span className="font-black text-lg">
                  <span className="text-[#4285F4]">G</span>
                  <span className="text-[#EA4335]">o</span>
                  <span className="text-[#FBBC05]">o</span>
                  <span className="text-[#4285F4]">g</span>
                  <span className="text-[#34A853]">l</span>
                  <span className="text-[#EA4335]">e</span>
               </span>
               <div className="flex-1 bg-slate-50 border border-slate-200 rounded-full px-4 py-1.5 flex items-center gap-2 text-xs text-slate-700">
                  <Search className="w-3.5 h-3.5 text-slate-400" />
                  <span className="font-medium">Mo's Diner • San Francisco, CA</span>
               </div>
            </div>

            {/* Admin Header Box "Your business on Google" */}
            <div className="bg-slate-50 border border-slate-200/80 rounded-xl p-4 space-y-4">
               <div className="flex justify-between items-center">
                  <div>
                     <h3 className="font-bold text-slate-900 text-sm">Your business on Google</h3>
                     <span className="text-[11px] text-blue-600 font-medium hover:underline cursor-pointer">See profile performance</span>
                  </div>
               </div>

               {/* 3 Main Action Buttons Pills */}
               <div className="flex flex-wrap gap-2">
                  <button className="bg-white hover:bg-slate-100 border border-slate-300 text-slate-800 text-xs font-bold px-3 py-1.5 rounded-lg flex items-center gap-1.5 shadow-2xs">
                     <Edit className="w-3.5 h-3.5 text-blue-600" /> Edit profile
                  </button>
                  <button className="bg-white hover:bg-slate-100 border border-slate-300 text-slate-800 text-xs font-bold px-3 py-1.5 rounded-lg flex items-center gap-1.5 shadow-2xs">
                     <Megaphone className="w-3.5 h-3.5 text-blue-600" /> Promote
                  </button>
                  <button className="bg-white hover:bg-slate-100 border border-slate-300 text-slate-800 text-xs font-bold px-3 py-1.5 rounded-lg flex items-center gap-1.5 shadow-2xs">
                     <Users className="w-3.5 h-3.5 text-blue-600" /> Customers
                  </button>
               </div>

               {/* Setup Cards Carousel */}
               <div className="grid grid-cols-2 gap-3 pt-1">
                  <div className="bg-white border border-slate-200 p-3 rounded-lg space-y-1">
                     <strong className="text-xs font-bold text-slate-900 block">Add photo</strong>
                     <p className="text-[10px] text-slate-500">Businesses with photos get more clicks from potential customers.</p>
                  </div>
                  <div className="bg-white border border-slate-200 p-3 rounded-lg space-y-1">
                     <strong className="text-xs font-bold text-slate-900 block">Add phone number</strong>
                     <p className="text-[10px] text-slate-500">Let customers call your business directly from Google Search.</p>
                  </div>
               </div>
            </div>

            {/* Popular Times Histogram Graph (Replicando a Imagem 2) */}
            <div className="bg-white border border-slate-200 rounded-xl p-4 space-y-3">
               <div className="flex justify-between items-center">
                  <span className="text-xs font-bold text-slate-900">Popular Times (Peak Visitor Movement)</span>
                  <span className="text-[10px] text-slate-500">Saturdays</span>
               </div>
               <div className="h-24 flex items-end gap-2 pt-2 border-b border-slate-200 pb-1">
                  {[20, 35, 55, 80, 100, 90, 75, 45, 30].map((val, idx) => (
                     <div key={idx} className="flex-1 flex flex-col items-center gap-1">
                        <div className="w-full bg-[#4285F4] rounded-t-sm" style={{ height: `${val}%` }} />
                     </div>
                  ))}
               </div>
               <div className="flex justify-between text-[9px] text-slate-400 font-mono">
                  <span>9a</span>
                  <span>12p</span>
                  <span>3p</span>
                  <span>6p</span>
                  <span>9p</span>
               </div>
            </div>

         </div>

         {/* RIGHT: MOBILE GMB PROFILE CARD (RECRIAÇÃO FIEL DA IMAGEM 3) */}
         <div className="lg:col-span-4 flex justify-center">
            <div className="w-[300px] bg-white border border-slate-300 rounded-[32px] overflow-hidden shadow-lg space-y-3 pb-4">
               
               {/* Cover Image */}
               <div className="h-36 bg-slate-200 relative">
                  <img 
                     src="https://images.unsplash.com/photo-1521017432531-fbd92d768814?q=80&w=400&auto=format&fit=crop" 
                     className="w-full h-full object-cover" 
                     alt="Saint Lou's Barbershop" 
                  />
               </div>

               {/* Profile Info */}
               <div className="px-4 space-y-2">
                  <div>
                     <h4 className="font-bold text-slate-900 text-base leading-tight">Saint Lou's Barbershop</h4>
                     <div className="flex items-center gap-1 text-xs mt-0.5">
                        <span className="font-black text-amber-500">4.8</span>
                        <div className="flex text-amber-400 text-[10px]">
                           ★★★★★
                        </div>
                        <span className="text-slate-500 text-[11px]">(102)</span>
                     </div>
                     <span className="text-[11px] text-slate-500 block">Barbershop in Halifax, Nova Scotia</span>
                  </div>

                  {/* Tabs */}
                  <div className="flex gap-3 text-[10px] font-bold text-slate-500 border-b border-slate-100 pb-1">
                     <span className="text-blue-600 border-b-2 border-blue-600 pb-1">OVERVIEW</span>
                     <span>SERVICES</span>
                     <span>REVIEWS</span>
                     <span>PHOTOS</span>
                  </div>

                  {/* Circular Action Buttons */}
                  <div className="grid grid-cols-4 gap-2 text-center pt-1">
                     <div className="flex flex-col items-center">
                        <div className="w-8 h-8 rounded-full bg-blue-50 border border-blue-200 text-blue-600 flex items-center justify-center">
                           <Phone className="w-3.5 h-3.5" />
                        </div>
                        <span className="text-[9px] font-bold text-slate-700 mt-1">CALL</span>
                     </div>
                     <div className="flex flex-col items-center">
                        <div className="w-8 h-8 rounded-full bg-blue-50 border border-blue-200 text-blue-600 flex items-center justify-center">
                           <MapPin className="w-3.5 h-3.5" />
                        </div>
                        <span className="text-[9px] font-bold text-slate-700 mt-1">DIRECTIONS</span>
                     </div>
                     <div className="flex flex-col items-center">
                        <div className="w-8 h-8 rounded-full bg-blue-50 border border-blue-200 text-blue-600 flex items-center justify-center">
                           <Bookmark className="w-3.5 h-3.5" />
                        </div>
                        <span className="text-[9px] font-bold text-slate-700 mt-1">SAVE</span>
                     </div>
                     <div className="flex flex-col items-center">
                        <div className="w-8 h-8 rounded-full bg-blue-50 border border-blue-200 text-blue-600 flex items-center justify-center">
                           <Globe className="w-3.5 h-3.5" />
                        </div>
                        <span className="text-[9px] font-bold text-slate-700 mt-1">WEBSITE</span>
                     </div>
                  </div>

                  {/* Full width quote button */}
                  <button className="w-full bg-blue-50 hover:bg-blue-100 text-blue-700 font-bold text-xs py-2 rounded-xl border border-blue-200 transition-colors">
                     REQUEST A QUOTE
                  </button>

                  {/* Address & Hours */}
                  <div className="text-[11px] text-slate-600 pt-1 space-y-1">
                     <p className="flex items-center gap-1.5"><MapPin className="w-3 h-3 text-red-500" /> 1869 Upper Water St, Halifax</p>
                     <p className="text-emerald-600 font-bold">Open • Closes 6:00 PM</p>
                  </div>
               </div>

            </div>
         </div>

      </div>

    </div>
  );
};
